import React, { useState } from "react";
import Container from "@cloudscape-design/components/container";
import Header from "@cloudscape-design/components/header";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Button from "@cloudscape-design/components/button";
import Alert from "@cloudscape-design/components/alert";
import Box from "@cloudscape-design/components/box";
import { signInWithMidway } from "../auth";
import { useTranslation } from "react-i18next";

export default function LoginPage() {
  const { t } = useTranslation();
  const [error, setError] = useState("");

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f2f3f3",
      }}
    >
      <Container header={<Header variant="h1">{t("app.main.title")}</Header>}>
        <SpaceBetween size="l">
          {error && (
            <Alert type="error" dismissible onDismiss={() => setError("")}>
              {error}
            </Alert>
          )}

          <Box textAlign="center" padding={{ top: "l", bottom: "l" }}>
            <SpaceBetween size="m">
              <Box color="text-body-secondary">{t("auth.action.sign-in-desc")}</Box>
              <Button variant="primary" iconName="external" onClick={signInWithMidway} fullWidth>
                {t("auth.action.sign-in-midway")}
              </Button>
            </SpaceBetween>
          </Box>
        </SpaceBetween>
      </Container>
    </div>
  );
}
